import React, {Fragment, useState} from 'react';
import cn from 'classnames';
import { differentDays } from '../Utils';
import { formatDateOnly, truncateStrMiddle } from './Utils';
import SvgIcon from '../../../common/SvgIcon';

const DesignerBooking = ({ booking, upcoming, onBookingClick, previousBooking, currentTime }) => {
  // const [currentDate, setCurrentDate] = useState(new Date());
  const dateObj = new Date(booking.time_from);
  const createdAt = formatDateOnly(new Date(booking.created_at));
  const time = dateObj.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: false });
  const cTime = currentTime.toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: false, second: '2-digit' });
  const dow = dateObj.toLocaleDateString("en-US", { weekday: 'short' });
  const date = dateObj.toLocaleDateString("en-US", { day: '2-digit' });
  const month = dateObj.toLocaleDateString("en-US", { month: 'long' });
  const prevDateObj = previousBooking ? new Date(previousBooking.time_from) : null;
  const differentDates = differentDays(dateObj, prevDateObj);
  // const londonDate = new Date(dateObj.toLocaleString("en-US", { timeZone: "Europe/London" }));
  // const inPast = currentTime > londonDate;
  const inPast = !upcoming;
  const cancelled = booking.status === 'cancelled';
  const { documents, designer } = booking;
  const { reassigned_designer: reassignedDesigner } = booking;
  const hubSpotFormUrl = booking => {
    let baseUrl = 'https://share.hsforms.com/1pSIrIGFuRHurIXszIAdpTA2r5wv?';
    baseUrl += `&email=${booking.email}`;
    baseUrl += `&fc_designer_s_email=${reassignedDesigner && reassignedDesigner.email || designer.email}`;
    baseUrl += `&mbr_designer_name=${reassignedDesigner && reassignedDesigner.full_name || designer.full_name}`;
    baseUrl += `&free_consultation_date_booking_was_made=${createdAt}`;
    baseUrl += `&free_consultation_call_date_and_time=${formatDateOnly(dateObj)}`;
    baseUrl += `&notes_to_designer=${encodeURIComponent(booking.note)}`;

    return baseUrl;
  };

  return (
    <Fragment>
      {differentDates && (
        <div className={cn('designer-booking -date-line', { '-in-past': inPast })}>
          <div className='booking-info'>
            <div className='booking-start -date'>
              <div className='date'>{date}</div>
              <div className='month'>{month}</div>
              <div className='dow'>{`${dow}`}</div>
            </div>
          </div>
        </div>
      )}
      <div className={cn('designer-booking', { '-in-past': inPast, '-cancelled': cancelled })}>
        <div className="booking-info">
          <div className='booking-start -time'>
            <div>{time}</div>
          </div>
          <div className={'customer-name'}>
            <div>
              <span>{booking.first_name}</span>
              <span>{booking.last_name}</span>
            </div>
            <div>
              <span className='email'>{booking.email}</span>
              <span className='phone'>{booking.phone}</span>
            </div>
          </div>
        </div>
        <div className={'customer-info'}>
          <div className={'customer-data'}>
            <div className={'booking-note'}>
              {booking.note}
              {booking.note.length === 0 && (
                <span className={'no-description'}> Client did not provide notes</span>
              )}
            </div>
            <div className='booking-documents'>
              {documents.map(document => (
                <div key={document.id} className='booking-document'>
                  <a target='_blank' href={document.url} className='booking-document'>
                    <SvgIcon icon='icon-chat-mediaFiles'/>
                    {truncateStrMiddle(document.filename, 25)}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={'booking-actions'}>
          <div className='action meeting-link'>
            <a className={cn('btn -empty -y2023')} href={booking.call_start_url} target='_blank'>Start Call</a>
          </div>
          <div className='action feedback'>
            <a className={cn('btn -empty -y2023')} target='_blank' href={hubSpotFormUrl(booking)}>Customer Form</a>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default DesignerBooking;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/DesignerBooking.js